export default "__VITE_ASSET__CpI2D3nX__"